// extracted by mini-css-extract-plugin
module.exports = {"header":"browser_update_header__2ssWO","icon":"browser_update_icon__3yvXp","notification":"browser_update_notification__fHeUr"};